<template>
<div>
  <div class="sup_switch--bars housemod">
    <div class="bars_text">
      <h4></h4>
      <p> {{ bar.value | tenThousandCurrency }}<span>萬元</span></p>
    </div>
    <div class="bars1">
      <input type="range" id="bar"
             step="100000"
             :min="bar.min"
             :max="bar.max"
             v-model.number="bar.value"
             @change="setPostData"
      >
    </div>
  </div>
  <div>
    <p>{{ bar.tip }}</p>
  </div>
</div>

</template>

<script>
import {dispatch} from "vuex-pathify";

export default {
  name: "bar",
  props: {
    bar: Object,
    page_no: Number
  },
  data: function () {
    return {}
  },
  methods: {
    setPostData() {
      let moduleName = store.get('moduleName')
      dispatch(`${moduleName}/setPostData`, {page_no: this.page_no, page_answer: this.bar.value})
    },
    setBarRange() {
      $(function () {
        var r = $('#bar');
        let max = (r[0].attributes.max.nodeValue)
        bg(r.val(), max);
        r.on('mouseenter', function () {
          var p = r.val();
          r.on('click', function () {
            p = r.val();
            bg(p, max);
          });
          r.on('mousemove', function () {
            p = r.val();
            bg(p, max);
          });
        });

        r.on('touchstart', function () {
          var p = r.val();
          r.on('click', function () {
            p = r.val();
          });
          r.on('touchmove', function () {
            p = r.val();
            bg(p, max);
          });
          r.on('touchend', function () {
            p = r.val();
            bg(p, max);
          });
        });

        function bg(n, max) {
          let v = (n*100 / max)
          r.css({
            'background-image': '-webkit-linear-gradient(left ,#EF8370 0%,#EF8370 ' + v + '%,#f2f2f2 ' + v + '%, #f2f2f2 100%)'
          });
        }
      });
    }
  },
  filters: {
    tenThousandCurrency(value) {
      var num = (Math.round(value / 10000) || 0).toString(), result = '';
      while (num.length > 3) {
        result = ',' + num.slice(-3) + result;
        num = num.slice(0, num.length - 3);
      }
      if (num) {
        result = num + result;
      }
      if (!result.indexOf('-,')) result = result.replace('-,', '-')
      return result;
    },
  },
  created() {
    this.setBarRange()
    this.setPostData()
  },
  mounted() {

  },
  computed: {}
}

</script>